import { render, staticRenderFns } from "./hold-req-msg.vue?vue&type=template&id=60f0b94e&scoped=true"
import script from "./hold-req-msg.vue?vue&type=script&lang=js"
export * from "./hold-req-msg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f0b94e",
  null
  
)

export default component.exports